import React from 'react';
import { NavLink } from 'react-router-dom';

export const UserProfileBreadcrumb = () => {
    return (
        <nav aria-label="breadcrumb">
            <div className="breadcrumb">
                <NavLink className="breadcrumb-item text-decoration-none" to="/">
                    Home
                </NavLink>
                <NavLink className="breadcrumb-item text-decoration-none" to="/user">
                    User
                </NavLink>
                <NavLink className="breadcrumb-item text-decoration-none" to="/user">
                    Profile
                </NavLink>
            </div>
        </nav>
    );
};
